export default __webpack_public_path__ + "fonts/FailedListings-White.svg";